module.exports = __webpack_public_path__ + "img/1538717395.5df91713.jpg";